import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
const Ctx = createContext(null);
export function LangProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        const stored = localStorage.getItem('tt_lang');
        return stored === 'cn' ? 'cn' : 'tw';
    });
    useEffect(() => { localStorage.setItem('tt_lang', lang); }, [lang]);
    const setLang = (l) => setLangState(l);
    const T = (tw, cn) => (lang === 'cn' ? cn : tw);
    return _jsx(Ctx.Provider, { value: { lang, setLang, T }, children: children });
}
export function useLang() {
    const v = useContext(Ctx);
    if (!v)
        throw new Error('LangProvider missing');
    return v;
}
